export default __webpack_public_path__ + "static/media/NFTDROPLIST-LOGO-248x300.80597050.png";